module.exports = __webpack_public_path__ + "AdobeStock_161673435_shaded.png?2c649b15ce281ffa66a4c3b7a0404876";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/landing/AdobeStock_161673435_shaded.png
// module id = 312
// module chunks = 0